import { render } from "./FrmWorkerRecords.vue?vue&type=template&id=282f3bc3"
import script from "./FrmWorkerRecords.vue?vue&type=script&lang=js"
export * from "./FrmWorkerRecords.vue?vue&type=script&lang=js"

import "./FrmWorkerRecords.vue?vue&type=style&index=0&id=282f3bc3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__